/**
 * Accessible status notification utility.
 * Replaces window.alert() with an aria-live region for screen reader announcements
 * and a visual toast notification.
 *
 * Usage: import { showNotification } from '../StatusNotification';
 *        showNotification("Form submitted successfully", "success");
 *        showNotification("An error occurred", "error");
 */

let notificationContainer = null;
let dismissTimer = null;

function ensureContainer() {
    if (notificationContainer && document.body.contains(notificationContainer)) {
        return notificationContainer;
    }

    notificationContainer = document.createElement('div');
    notificationContainer.id = 'status-notification-container';
    notificationContainer.setAttribute('role', 'status');
    notificationContainer.setAttribute('aria-live', 'assertive');
    notificationContainer.setAttribute('aria-atomic', 'true');
    notificationContainer.className = 'status-notification-container';
    document.body.appendChild(notificationContainer);

    return notificationContainer;
}

export function showNotification(message, type = 'info', autoDismissMs = 6000) {
    let container = ensureContainer();

    // Clear any existing dismiss timer
    if (dismissTimer) {
        clearTimeout(dismissTimer);
        dismissTimer = null;
    }

    // Set classes based on type
    let typeClass = 'status-notification--' + type;
    container.className = 'status-notification-container status-notification-visible ' + typeClass;

    // Create inner content
    container.innerHTML = '';

    let messageEl = document.createElement('span');
    messageEl.className = 'status-notification-message';
    messageEl.textContent = message;
    container.appendChild(messageEl);

    let closeBtn = document.createElement('button');
    closeBtn.type = 'button';
    closeBtn.className = 'status-notification-close';
    closeBtn.setAttribute('aria-label', 'Dismiss notification');
    closeBtn.textContent = '\u00D7';
    closeBtn.addEventListener('click', function () {
        dismissNotification();
    });
    container.appendChild(closeBtn);

    // Auto-dismiss (longer for errors)
    let dismissTime = type === 'error' ? Math.max(autoDismissMs, 10000) : autoDismissMs;
    dismissTimer = setTimeout(function () {
        dismissNotification();
    }, dismissTime);
}

export function dismissNotification() {
    if (notificationContainer) {
        notificationContainer.className = 'status-notification-container';
        notificationContainer.innerHTML = '';
    }
    if (dismissTimer) {
        clearTimeout(dismissTimer);
        dismissTimer = null;
    }
}
